// @ts-nocheck
// Content moderation utilities for messaging safety

// Hard-banned terms (slurs) - NEVER allow these
const HARD_BANNED_TERMS = [
  // Add slurs and hate speech terms here
  // This is just a starter list - expand as needed
  'nigger', 'nigga', 'faggot', 'retard', 'tranny',
  // Add more as appropriate for your community
];

// Profanity terms - warn but allow
const PROFANITY_TERMS = [
  'fuck', 'shit', 'bitch', 'ass', 'damn', 'hell', 'crap',
  'dick', 'cock', 'pussy', 'bastard', 'asshole'
];

/**
 * Check if text contains banned terms
 * @param {string} text - Message text to check
 * @returns {{ banned: boolean, profanity: boolean, term?: string }}
 */
export function containsBannedTerms(text) {
  if (!text || typeof text !== 'string') {
    return { banned: false, profanity: false };
  }

  const normalized = text.toLowerCase();

  // Check for hard-banned slurs
  for (const term of HARD_BANNED_TERMS) {
    if (normalized.includes(term)) {
      return { banned: true, profanity: false, term };
    }
  }

  // Check for profanity
  for (const term of PROFANITY_TERMS) {
    // Use word boundaries to avoid false positives (e.g., "assassin" contains "ass")
    const regex = new RegExp(`\\b${term}\\b`, 'i');
    if (regex.test(text)) {
      return { banned: false, profanity: true, term };
    }
  }

  return { banned: false, profanity: false };
}
